<script lang="ts" setup>
definePageMeta({
  layout: 'basic'
})
</script>

<template>
  <section class="p-5 flex-col-center text-base text-center text-neutral-800">
    <Icon class="mb-10" name="logos:evergreen-icon" alt="Icon" width="96" height="96" />

    <h1 class="mb-4 text-3xl font-medium">
      Browser is not supported
    </h1>
    <p class="max-w-500px opacity-80 leading-snug">
      Vocal doesn't support your current environment.
      Please update your browser or Outlook app.
    </p>
  </section>
</template>
